import { onBeforeUnmount, onMounted } from "vue";
import { onBeforeRouteLeave } from "vue-router";

import { useIndividStore, useAuthStore } from "@/stores";

export const useConfirmNavigation = () => {
  const individStore = useIndividStore();
  const authStore = useAuthStore();

  onMounted(async () => {
    window.addEventListener("beforeunload", beforeWindowUnload);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("beforeunload", beforeWindowUnload);
  });

  onBeforeRouteLeave((_to, _from, next) => {
    if (confirm("Är du säker på att du vill lämna sidan?")) {
      individStore.$reset();
      next();
    } else {
      next(false);
    }
  });

  const beforeWindowUnload = (e: BeforeUnloadEvent) => {
    // Bypass confirmation if the user is logging out
    if (authStore.loggingOut) {
      return;
    }
    
    e.preventDefault();
    e.returnValue = "";
  };
};
